import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/global-board/icons/briefcase.svg'
import _imports_1 from '@/assets/global-board/icons/timer.svg'
import _imports_2 from '@/assets/global-board/icons/money.svg'


const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "bg-white px-4 py-8 shadow-card rounded-2xl transform transition duration-300 zoom" }
const _hoisted_3 = { class: "flex flex-row justify-between w-full items-end" }
const _hoisted_4 = { class: "font-thin text-gray-500 text-sm capitalize-letter" }
const _hoisted_5 = { class: "font-thin text-gray-500 text-sm capitalize-letter" }
const _hoisted_6 = { class: "flex flex-col mt-2 justify-center items-center p-2 space-y-4" }
const _hoisted_7 = { class: "w-24 h-24 rounded-lg shadow-card" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "font-semibold text-lg text-gray-700 text-center w-full truncate" }
const _hoisted_10 = { class: "w-full justify-center flex flex-col items-center" }
const _hoisted_11 = { class: "flex flex-col mt-2 w-2/3 justify-center space-y-2" }
const _hoisted_12 = { class: "flex flex-row items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-3 text-gray-300",
  width: ""
}, null, -1)
const _hoisted_14 = { class: "flex flex-row items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-3 text-gray-300",
  width: ""
}, null, -1)
const _hoisted_16 = { class: "text-gray-600 text-sm capitalize" }
const _hoisted_17 = { class: "flex flex-col items-center justify-start w-full" }
const _hoisted_18 = { class: "flex flex-row items-start w-full" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mr-3 text-gray-300",
  width: ""
}, null, -1)
const _hoisted_20 = { class: "text-gray-600 text-sm block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "w-full justify-center items-center p-2 cursor-pointer",
      key: index,
      onClick: ($event: any) => (
      _ctx.$router.push(`/companies/${job.company?.domain_name}/jobs/${job.id}`)
    )
    }, [
      _createElementVNode("a", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(job.job_location?.location
              ? job.job_location?.location.city +
                "," +
                job.job_location?.location.country
              : ""), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.timeAgo(job.publish_date)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (job.company?.logo?.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "object-cover bg-white rounded-lg w-full h-full",
                    src: job.company?.logo?.url
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(job.title), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", {
                  class: _normalizeClass(["text-primary text-base font-semibold w-full truncate", _ctx.branding.accentColor])
                }, _toDisplayString(job.company?.visible_name), 3)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(job.employment_type
                    ? String(job.employment_type).replaceAll("_", " ")
                    : "N/A") + " " + _toDisplayString(job.is_remote ? "- Remote" : ""), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, "$" + _toDisplayString(job.salary_min ? _ctx.numberWithCommas(job.salary_min) : 0) + " - $" + _toDisplayString(job.salary_max ? _ctx.numberWithCommas(job.salary_max) : 0) + " " + _toDisplayString(job.currency_salary) + " per year ", 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_1))
  }), 128))
}